import React, { CSSProperties } from 'react'
import { useDisplays } from '../../../services/displayservices/DisplayProvider';

const DisplayImage = () => {
    const {display,getDisplays,getDisplayProperty} = useDisplays();
    const getImageStyle = ():CSSProperties => {
        let dispWid = getDisplayProperty("Width");
        let dispHei = getDisplayProperty("Height");
        let cs:CSSProperties = {
            height: dispHei + "px",
            width: dispWid + "px",            
            
        }
        return cs;
    }   
  return (
    <div style={getImageStyle()}>
        <img style={getImageStyle()} src="img/ice_back.jpg" />
    </div>
  )
}
export default DisplayImage